module.exports = __webpack_public_path__ + "img/right_pic.47ff9cc1.png";